"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureArrayToMap = exports.featureObjToMap = exports.featureMapToArray = exports.featureMapToObj = exports.featureArrayToUniqueMap = exports.TestOrgFeatures = exports.DefaultOrgFeatures = exports.TeamboardFeatures = exports.UserFeatures = exports.FeatureSets = void 0;
const StaffUserType_1 = __importDefault(require("@opsbase/lib-auth/StaffUserType"));
const SuperUserType_1 = __importDefault(require("@opsbase/lib-auth/SuperUserType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const App_1 = __importDefault(require("../App"));
const Feature_1 = __importDefault(require("../Feature"));
const FeatureStatus_1 = __importDefault(require("../FeatureStatus"));
class FeatureData {
    constructor(o) {
        this.key = '';
        this.title = '';
        this.orgFeature = false;
        this.userFeature = false;
        this.employee = false;
        this.teamboard = false;
        this.defaultOrg = false;
        this.admin = false;
        this.primaryAdmin = false;
        this.superUser = false;
        this.superAdmin = false;
        Object.assign(this, o);
    }
    asFeature(type) {
        return [this.key, this[type] === true ? FeatureStatus_1.default.ENABLED : FeatureStatus_1.default.DISABLED];
    }
}
const OrgFeatureDefaultOn = {
    orgFeature: true,
    defaultOrg: true,
    testOrg: true,
};
const OrgFeatureDefaultOff = {
    orgFeature: true,
    defaultOrg: false,
    testOrg: true,
};
const SuperAdminFeature = {
    userFeature: true,
    superAdmin: true,
};
const SuperUserFeature = {
    userFeature: true,
    superAdmin: true,
    superUser: true,
};
const PrimaryAdminFeature = {
    userFeature: true,
    superAdmin: true,
    superUser: true,
    primaryAdmin: true,
    admin: false,
};
const AdminFeature = {
    userFeature: true,
    superAdmin: true,
    superUser: true,
    primaryAdmin: true,
    admin: true,
};
const StaffFeature = {
    userFeature: true,
    employee: true,
    admin: true,
    primaryAdmin: true,
    teamboard: true,
};
exports.FeatureSets = {
    [App_1.default.OPSBASE]: {
        TODO: new FeatureData(Object.assign({ key: 'TODO', title: 'ToDo' }, StaffFeature)),
        OPS_LOG: new FeatureData(Object.assign(Object.assign({ key: '7', title: () => lib_i18n_1.default.t('ops_log') }, OrgFeatureDefaultOn), AdminFeature)),
        OPS_SCORING: new FeatureData(Object.assign(Object.assign({ key: '16', title: () => lib_i18n_1.default.t('ops_scoring') }, OrgFeatureDefaultOff), AdminFeature)),
        ISSUES_LOG: new FeatureData(Object.assign(Object.assign({ key: '9', title: () => lib_i18n_1.default.t('issues_log') }, OrgFeatureDefaultOn), AdminFeature)),
        OPS_MANAGEMENT: new FeatureData(Object.assign(Object.assign({ key: '6', title: () => lib_i18n_1.default.t('ops_management') }, OrgFeatureDefaultOn), AdminFeature)),
        ONBOARDING_WIZARD: new FeatureData(Object.assign(Object.assign({ key: 'ONBOARDING', title: () => lib_i18n_1.default.t('onboarding_wizard') }, OrgFeatureDefaultOn), AdminFeature)),
        QUESTIONBANK: new FeatureData(Object.assign({ key: 'QUESTIONBANK', title: () => lib_i18n_1.default.t('question-bank') }, OrgFeatureDefaultOff)),
        PEOPLE_MANAGEMENT: new FeatureData(Object.assign({ key: '3', title: () => lib_i18n_1.default.t('people_management') }, AdminFeature)),
        PEOPLE_MANAGEMENT_DELETION: new FeatureData(Object.assign({ key: '3.1', title: () => lib_i18n_1.default.t('people_management_deletion') }, PrimaryAdminFeature)),
        PEOPLE_MANAGEMENT_CHANGEUSERTYPE: new FeatureData(Object.assign({ key: '3.2', title: () => lib_i18n_1.default.t('people_management_changeusertype') }, PrimaryAdminFeature)),
        PEOPLE_MANAGEMENT_GROUPS: new FeatureData(Object.assign({ key: '3.3', title: () => lib_i18n_1.default.t('people_management_groups') }, PrimaryAdminFeature)),
        PLACES_MANAGEMENT: new FeatureData(Object.assign({ key: '20', title: () => lib_i18n_1.default.t('places_management') }, AdminFeature)),
        ASSET_MANAGEMENT: new FeatureData(Object.assign(Object.assign({ key: '13', title: () => lib_i18n_1.default.t('asset_management') }, OrgFeatureDefaultOn), AdminFeature)),
        WORKFLOW_MANAGEMENT: new FeatureData(Object.assign({ key: 'WORKFLOW', title: () => lib_i18n_1.default.t('workflow_management') }, AdminFeature)),
        TEAMBOARD_MANAGEMENT: new FeatureData(Object.assign(Object.assign({ key: '15', title: () => lib_i18n_1.default.t('teamboard_management') }, OrgFeatureDefaultOn), AdminFeature)),
        ORG_SETTINGS: new FeatureData(Object.assign({ key: '1', title: () => lib_i18n_1.default.t('org_settings') }, PrimaryAdminFeature)),
        GRAPHQL_PLAYGROUND: new FeatureData(Object.assign({ key: '18', title: () => lib_i18n_1.default.t('graphql_playground') }, AdminFeature)),
        REPORT_MANAGEMENT: new FeatureData(Object.assign({ key: '21', title: () => lib_i18n_1.default.t('report_management') }, AdminFeature)),
        INTEGRATIONS_IOT: new FeatureData(Object.assign(Object.assign({ key: 'INTEGRATIONS_IOT', title: () => lib_i18n_1.default.t('integrations_iot') }, OrgFeatureDefaultOff), AdminFeature)),
        INTEGRATIONS_API: new FeatureData(Object.assign(Object.assign({ key: 'INTEGRATIONS_API', title: () => lib_i18n_1.default.t('integrations_api') }, OrgFeatureDefaultOff), AdminFeature)),
        INTEGRATIONS_IQM: new FeatureData(Object.assign(Object.assign({ key: 'INTEGRATIONS_IQM', title: () => lib_i18n_1.default.t('integrations_iqm') }, OrgFeatureDefaultOff), AdminFeature)),
        DASHBOARD: new FeatureData(Object.assign({ key: '22', title: () => lib_i18n_1.default.t('dashboard') }, AdminFeature)),
        MULTILANGUAGE_SUPPORT: new FeatureData(Object.assign(Object.assign({ key: 'MULTILANGUAGE_SUPPORT', title: () => lib_i18n_1.default.t('multilanguage_support') }, OrgFeatureDefaultOff), AdminFeature)),
    },
    // ADMIN BASE
    [App_1.default.ADMINBASE]: {
        ORG_MANAGEMENT: new FeatureData(Object.assign({ key: '31', title: () => lib_i18n_1.default.t('org_management') }, SuperUserFeature)),
        SUPERUSER_MANAGEMENT: new FeatureData(Object.assign({ key: '32', title: () => lib_i18n_1.default.t('superuser_management') }, SuperAdminFeature)),
        ORG_DELETION: new FeatureData(Object.assign({ key: '33', title: () => lib_i18n_1.default.t('org_deletion') }, SuperAdminFeature)),
        TASK_MANAGEMENT: new FeatureData(Object.assign({ key: '34', title: () => lib_i18n_1.default.t('task_management') }, SuperAdminFeature)),
        TEMPLATES_MANAGEMENT: new FeatureData(Object.assign({ key: '35', title: () => lib_i18n_1.default.t('templates_management') }, SuperUserFeature)),
        SYSTEMSETTINGS_MANAGEMENT: new FeatureData(Object.assign({ key: '36', title: () => lib_i18n_1.default.t('systemsettings_management') }, SuperAdminFeature)),
        GRAPHQL_PLAYGROUND: new FeatureData(Object.assign({ key: 'GRAPHQL_PLAYGROUND', title: () => lib_i18n_1.default.t('graphql_playground') }, SuperAdminFeature)),
    },
    // OPS BOARD
    [App_1.default.NATIVEBOARD]: {
        OPS: new FeatureData(Object.assign(Object.assign({ key: '41', title: () => lib_i18n_1.default.t('ops') }, OrgFeatureDefaultOn), StaffFeature)),
        ISSUES: new FeatureData(Object.assign(Object.assign({ key: '44', title: () => lib_i18n_1.default.t('issues') }, OrgFeatureDefaultOn), StaffFeature)),
    },
    // LIBRARY
    [App_1.default.LIBRARY]: {
        LIBRARY: new FeatureData(Object.assign({ key: '51', title: () => lib_i18n_1.default.t('library') }, SuperAdminFeature)),
    },
};
exports.default = exports.FeatureSets;
/**
 * Shorthand to make the code cleaner
 */
const adminFS = Object.values(exports.FeatureSets[App_1.default.ADMINBASE]), opsbaseFS = Object.values(exports.FeatureSets[App_1.default.OPSBASE]), nativeboardFS = Object.values(exports.FeatureSets[App_1.default.NATIVEBOARD]);
function getUserFeatureMap(type) {
    return new Map([...opsbaseFS, ...adminFS, ...nativeboardFS]
        .filter(f => f.userFeature)
        .map(f => f.asFeature(type)));
}
function getOrgFeatureMap(type) {
    return new Map([...opsbaseFS, ...adminFS, ...nativeboardFS]
        .filter(f => f.orgFeature)
        .map(f => f.asFeature(type)));
}
exports.UserFeatures = {
    [StaffUserType_1.default.EMPLOYEE]: getUserFeatureMap('employee'),
    [StaffUserType_1.default.ADMIN]: getUserFeatureMap('admin'),
    [StaffUserType_1.default.PRIMARYADMIN]: getUserFeatureMap('primaryAdmin'),
    [SuperUserType_1.default.SUPERUSER]: getUserFeatureMap('superUser'),
    [SuperUserType_1.default.SUPERADMIN]: getUserFeatureMap('superAdmin'),
};
exports.TeamboardFeatures = getUserFeatureMap('teamboard');
exports.DefaultOrgFeatures = getOrgFeatureMap('defaultOrg');
exports.TestOrgFeatures = getOrgFeatureMap('testOrg');
const featureArrayToUniqueMap = (a) => {
    const res = new Map(exports.DefaultOrgFeatures);
    res.forEach((v, k) => {
        if (v === FeatureStatus_1.default.ENABLED)
            res.set(k, FeatureStatus_1.default.DISABLED);
    });
    a.forEach(k => res.set(k, FeatureStatus_1.default.ENABLED));
    return res;
};
exports.featureArrayToUniqueMap = featureArrayToUniqueMap;
function featureMapToObj(map) {
    const obj = {};
    map.forEach((v, k) => {
        obj[k] = v;
    });
    return obj;
}
exports.featureMapToObj = featureMapToObj;
function featureMapToArray(map) {
    return [...(map || [])].map(([name, state]) => new Feature_1.default({ name, state }));
}
exports.featureMapToArray = featureMapToArray;
function featureObjToMap(obj) {
    const map = new Map();
    Object.keys(obj).forEach(k => {
        map.set(k, obj[k]);
    });
    return map;
}
exports.featureObjToMap = featureObjToMap;
function featureArrayToMap(arr) {
    const map = new Map();
    arr.forEach(v => {
        map.set(v.name, v.state);
    });
    return map;
}
exports.featureArrayToMap = featureArrayToMap;
